import { WorkingArea } from '@/constants/user/userWorkingArea'

export const getWorkingAreaName = (workingArea: number): string => {
	return WorkingArea[workingArea] || 'Unknown'
}
